import { render, staticRenderFns } from "./expR.vue?vue&type=template&id=5d10d6d4"
import script from "./expR.vue?vue&type=script&lang=js"
export * from "./expR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports